import React from "react";
import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";
import LinkTree from "../../components/link-tree/link-tree";

export default function ThankYouQ() {
    return (
        <>
            <Header></Header>
            <div style={{fontSize: '36px'}}>Thank you for joining The Quantity!</div>
            <div>Check out my social media while you're here :)</div>
            <LinkTree></LinkTree>
            <div><a href="http://joshalmostt.com/">Back to Home</a></div>
            <Footer></Footer>
        </>
    )
}